import React, { useEffect } from 'react';
import './CatalogRequest.css';
import reliabilityValueImg from '../../images/reliability-value-img.jpg';
import castIronFeaturesImg from '../../images/cast-iron-features-img.jpg';
import xr3CatalogImg from '../../images/xr3-catalog-img.jpg';
import techtopBinderImg from '../../images/techtop-binder-img.jpg';
import CountryState from '../../components/CountryState/CountryState';
import Loader from '../../components/Loader/Loader';
import AlertMessage from '../../components/AlertMessage/AlertMessage';
import Select from "react-select";
import { Validation } from '../../validation';
import DownloadService from '../../services/DownloadService/DownloadService';
import { error } from 'jquery';

const titles = [
    "Purchasing",
    "Owner",
    "President",
    "Office Manager",
    "Administrative",
    "Assistant",
    "CEO",
    "Marketing",
    "Sales",
    "Vice President",
    "Secretary",
    "Warehouse",
    "Production",
    "Engineer"
];

const suite_apt = [
    "STE",
    "APT",
    "RM",
    "BLDG",
    "FL",
    "DEPT",
    "UNIT",
    "NONE"
];

const employee_locations = [
    "1-4",
    "5-9",
    "10-19",
    "20-49",
    "50-99",
    "100-999",
    "1000+"
];

class CatalogRequest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addNewAddress: false,
            showPassword: false,
            is_login: false,
            isLoaderVisible: false,
            errorMessage: "",
            alert:{ type: '', message: '' },
            formData: {
                user_id: 0,
                attn: "",
                full_name: "",
                company_name: "",
                title: "",
                address_1: "",
                address_2: "",
                suite_apt: "NONE",
                zip_code: "",
                city: "",
                country: null,
                state: null,
                phone_number: "",
                mobile_number: "",
                employee_location: "",
                email: "",
                confirm_email: "",
                password: "",
                selected_catalog: []
            },
            errors:{}
        };
        this.downloadService = new DownloadService();
    }

    componentDidMount() {
        document.title = "Catalog Request | Techtop Industries";
        let updatedState = {};
        console.log(Object.keys(localStorage).length);
        if(Object.keys(localStorage).length > 0) {
            Object.keys(localStorage).forEach((key) => {
                if (key.startsWith('techtop_')) {
                    updatedState[key.replace('techtop_', '')] = localStorage.getItem(key);
                } else {
                    updatedState[key] = localStorage.getItem(key);
                }
            });

            this.setState(updatedState);
        }
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                full_name: `${updatedState.user_first_name || ''} ${updatedState.user_last_name || ''}`.trim(),
                email: updatedState.user_email || '',
                company_name: updatedState.user_company || '',
                user_id: updatedState.user_id || 0,
                phone_number: (updatedState.user_phone !== 'None' ? updatedState.user_phone : ''),
                address_1: (updatedState.user_address !== 'None' ? updatedState.user_address : ''),
                city: (updatedState.user_city !== 'None' ? updatedState.user_city : ''),
                state: (updatedState.user_state !== 'None' ? updatedState.user_state : ''),
                zip_code: (updatedState.user_zip !== 'None' ? updatedState.user_zip : ''),
                country: (updatedState.user_country !== 'None' ? updatedState.user_country : '')
            }
        }));
        if(!updatedState.is_login) {
            this.setState({ addNewAddress: true });
        }
        console.log(updatedState);
    }

    handleLocationChange = (data) => {
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                country: data.country ? data.country.label : "",
                state: data.state ? data.state.label : ""
            },
            errors: {
                ...prevState.errors,
                country: "",
                state: ""
            }
        }));
    };

    handleChange(field, e){
        let { formData } = this.state; 
        const { name, value } = e.target;
        const newFormData = {
            ...formData,
            [name]: value,
        };
        console.log("Updated Form Data:", newFormData);
        this.setState({formData : newFormData});
    }

    handleCatalogChange = (e) => {
        const { value, checked } = e.target;
        const { formData } = this.state;

        let updatedCatalogs = [...formData.selected_catalog];

        if (checked) {
            updatedCatalogs.push(value);
        } else {
            updatedCatalogs = updatedCatalogs.filter(item => item !== value);
        }

        this.setState({
            formData: {
                ...formData,
                selected_catalog: updatedCatalogs
            }
        });
    };

    handleValidation() {

        const { is_login, addNewAddress ,formData } = this.state;

        let validationErrors = {};
        if(is_login && !addNewAddress) {
            validationErrors = Validation(formData, ['attn']);
        } else if(is_login && addNewAddress) {
            validationErrors = Validation(formData, [
                'attn',
                'full_name',
                'company_name',
                'title',
                'address_1',
                'zip_code',
                'city',
                'country',
                'state'
            ]);
        } else {
            validationErrors = Validation(formData, [
                'attn',
                'full_name',
                'company_name',
                'title',
                'address_1',
                'zip_code',
                'city',
                'country',
                'state',
                'phone_number',
                'email',
                'confirm_email'
            ]);
        }

        // Catalog validation
        if (!formData.selected_catalog || formData.selected_catalog.length === 0) {
            validationErrors.selected_catalog = "Please select at least one catalog";
        }

        // Password validation (optional)
        if(!is_login) {
            if (formData.password && formData.password.trim() !== "") {

                const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{6,20}$/;

                if (!passwordRegex.test(formData.password)) {
                    validationErrors.password =
                        "Password must be 6-20 characters and include at least 1 letter and 1 number.";
                }
            }
        }
        
        this.setState({ errors: validationErrors });

        return Object.keys(validationErrors).length === 0;
    }

    handleSubmit = (e) => {

        e.preventDefault();

        if (!this.handleValidation()) {
            return; // stop submission if validation fails
        }

        const { formData } = this.state;

        const payload = {
            ...formData
        };

        this.setState({ isLoaderVisible: true });

        this.downloadService.saveCatalogRequest(payload).then(response => {
            console.log("API Response:", response);
            if(response.status === 200) {
                if(response.data.status === "success") {
                    window.location.href = "/catalog-request-confirmation";
                } else {
                    this.setState({ alert: { type: 'danger', message: response.data.message || "There was an issue submitting your request. Please try again." } });
                    this.setState({ errorMessage: response.data.message || "There was an issue submitting your request. Please try again." });

                }
                // Optionally reset form or redirect user
            } else {
                this.setState({ alert: { type: 'danger', message: response.data.message || "There was an issue submitting your request. Please try again." } });
                this.setState({ errorMessage: response.data.message || "There was an issue submitting your request. Please try again." });
            }
        }).catch(error => {
            this.setState({ alert: { type: 'danger', message: error || "There was an issue submitting your request. Please try again." } });
                this.setState({ errorMessage: error || "There was an issue submitting your request. Please try again." });
        }).finally(() => {
            this.setState({ isLoaderVisible: false });
        });


        console.log("Submit Payload:", payload);

        // Call API here
    };

    togglePasswordVisibility() {
        this.setState(prevState => ({
            showPassword: !prevState.showPassword
        }));
    };

    handleAddAddress() {
        this.setState(prevState => ({
            addNewAddress: !prevState.addNewAddress
        }));
    }

    renderCatalogs() {
        const catalogs = [
            {
                name: "Techtop Binder",
                id: "selected_catalog_techtop_binder",
                img: techtopBinderImg,
                link: "https://online.flippingbook.com/shelf/391239/782262/"
            },
            {
                name: "XR3 Catalog",
                id: "selected_catalog_xr3_catalog",
                img: xr3CatalogImg,
                link: "https://online.flippingbook.com/shelf/391239/894500/"
            },
            {
                name: "Cast Iron Features",
                id: "selected_catalog_cast_iron_features",
                img: castIronFeaturesImg,
                link: "https://online.flippingbook.com/shelf/391239/817747/"
            },
            {
                name: "Reliability Value",
                id: "selected_catalog_reliability_value",
                img: reliabilityValueImg,
                link: "https://online.flippingbook.com/shelf/391239/601862/"
            }
        ];

        return catalogs.map((catalog, index) => (
            <div className="col-md-3" key={index}>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        value={catalog.name}
                        id={catalog.id}
                        name="selected_catalog"
                        onChange={this.handleCatalogChange}
                        checked={this.state.formData.selected_catalog.includes(catalog.name)}
                    />

                    <label className="form-check-label text-center w-100" htmlFor={catalog.id}>
                        <img
                            src={catalog.img}
                            alt={catalog.name}
                            className="img-fluid w-100"
                        />

                        <div className="mt-2">
                            <a
                                href={catalog.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-decoration-underline d-block"
                            >
                                {catalog.name}
                            </a>
                        </div>
                    </label>
                </div>
            </div>
        ));

    }

    renderForm() {
        let { is_login, addNewAddress, formData, user_first_name, user_last_name, user_company, errors } = this.state;
        
        // Helper to handle the "Full Name" initial value logic
        const defaultFullName = formData.full_name || `${user_first_name || ''} ${user_last_name || ''}`.trim();
        return (
            <React.Fragment>
                <div className="col-md-12">
                    {(addNewAddress && (
                        <React.Fragment>
                            {/* Full Name */}
                            <div className="mb-3 required-field">
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    name="full_name" 
                                    id="full_name" 
                                    placeholder="Full Name" 
                                    value={defaultFullName} 
                                    onChange={this.handleChange.bind(this, 'full_name')}
                                />
                                {errors.full_name && <div className="text-danger">{errors.full_name}</div>}
                            </div>

                            {/* Company */}
                            <div className="mb-3 required-field">
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    name="company_name" 
                                    id="company_name" 
                                    placeholder="Company" 
                                    value={formData.company_name || user_company || ''} 
                                    onChange={this.handleChange.bind(this, 'company_name')}
                                />
                                {errors.company_name && <div className="text-danger">{errors.company_name}</div>}
                            </div>

                            {/* Title */}
                            <div className="mb-3 required-field">
                                <Select
                                    options={titles.map(title => ({ value: title, label: title }))}
                                    value={formData.title ? { value: formData.title, label: formData.title } : null}
                                    onChange={(selectedOption) => this.handleChange('title', { target: { name: 'title', value: selectedOption.value } })}
                                    placeholder="Select Title..."
                                    isSearchable
                                />
                                {errors.title && <div className="text-danger">{errors.title}</div>}
                                
                            </div>

                            {/* Address Line 1 */}
                            <div className="mb-3 required-field">
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    name="address_1" 
                                    id="address_1" 
                                    placeholder="Address Line 1" 
                                    value={formData.address_1 || ''}
                                    onChange={this.handleChange.bind(this, 'address_1')}
                                />
                                {errors.address_1 && <div className="text-danger">{errors.address_1}</div>}
                            </div>

                            {/* Title */}
                            <div className="mb-3 required-field">
                                <Select
                                    options={suite_apt.map(title => ({ value: title, label: title }))}
                                    value={formData.suite_apt ? { value: formData.suite_apt, label: formData.suite_apt } : null}
                                    onChange={(selectedOption) => this.handleChange('suite_apt', { target: { name: 'suite_apt', value: selectedOption.value } })}
                                    placeholder="Select Suite/Apt..."
                                    isSearchable
                                />
                                
                            </div>

                            {/* Address Line 2 */}
                            <div className="mb-3">
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    name="address_2" 
                                    id="address_2" 
                                    placeholder="Address Line 2 (optional)" 
                                    value={formData.address_2 || ''}
                                    onChange={this.handleChange.bind(this, 'address_2')}
                                />
                            </div>

                            {/* Zip Code */}
                            <div className="mb-3 required-field">
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    name="zip_code" 
                                    id="zip_code" 
                                    placeholder="Zip Code" 
                                    value={formData.zip_code || ''}
                                    onChange={this.handleChange.bind(this, 'zip_code')}
                                />
                                {errors.zip_code && <div className="text-danger">{errors.zip_code}</div>}
                            </div>

                            {/* City */}
                            <div className="mb-3 required-field">
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    name="city" 
                                    id="city" 
                                    placeholder="City" 
                                    value={formData.city || ''}
                                    onChange={this.handleChange.bind(this, 'city')}
                                />
                                {errors.city && <div className="text-danger">{errors.city}</div>}
                            </div>

                            {/* Country & State Component */}
                            <CountryState onChange={this.handleLocationChange} errors={errors}/>

                            {/* Phone Number */}
                            {(!is_login) && (
                                <React.Fragment>
                                    <div className="mb-3 required-field">
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="phone_number" 
                                            id="phone_number" 
                                            placeholder="Phone Number" 
                                            value={formData.phone_number || ''}
                                            onChange={this.handleChange.bind(this, 'phone_number')}
                                        />
                                        {errors.phone_number && <div className="text-danger">{errors.phone_number}</div>}
                                    </div>

                                    {/* Mobile Number */}
                                    <div className="mb-3">
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="mobile_number" 
                                            id="mobile_number" 
                                            placeholder="Mobile Number (optional)" 
                                            value={formData.mobile_number || ''}
                                            onChange={this.handleChange.bind(this, 'mobile_number')}
                                        />
                                    </div>
                                    <hr />
                                    {/* Employees of location */}
                                    <div className="mb-3">
                                        <select
                                            className="form-select"
                                            name="employee_location"
                                            id="employee_location"
                                            value={formData.employee_location || ''}
                                            onChange={this.handleChange.bind(this, 'employee_location')}
                                        >
                                            <option value="">Select # of Employees</option>
                                            {employee_locations.map(location => (
                                                <option key={location} value={location}>
                                                    {location}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {/* Email */}
                                    <div className="mb-3 required-field">
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            name="email" 
                                            id="email" 
                                            placeholder="Email" 
                                            value={formData.email || ''}
                                            onChange={this.handleChange.bind(this, 'email')}
                                        />
                                        {errors.email && <div className="text-danger">{errors.email}</div>}
                                    </div>

                                    {/* Confirm Email */}
                                    <div className="mb-3 required-field">
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            name="confirm_email" 
                                            id="confirm_email" 
                                            placeholder="Confirm Email" 
                                            value={formData.confirm_email || ''}
                                            onChange={this.handleChange.bind(this, 'confirm_email')}
                                        />
                                        {errors.confirm_email && <div className="text-danger">{errors.confirm_email}</div>}
                                    </div>

                                    <div className="mb-2">
                                        <div className="input-group">
                                            <input
                                                type={this.state.showPassword ? "text" : "password"}
                                                className="form-control"
                                                name="password"
                                                placeholder="Password (optional)"
                                                value={formData.password || ""}
                                                onChange={this.handleChange.bind(this, "password")}
                                            />

                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary"
                                                onClick={this.togglePasswordVisibility.bind(this)}
                                            >
                                                {this.state.showPassword ? "Hide" : "Show"}
                                            </button>
                                        </div>

                                        <ul className="mt-2 mb-0 ps-3" style={{fontSize:"13px"}}>
                                            <li>6-20 characters</li>
                                            <li>1 letter</li>
                                            <li>1 number</li>
                                        </ul>
                                        {errors.password && <div className="text-danger">{errors.password}</div>}
                                    </div>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    ))}

                    <div className="mb-3">
                        <button type="submit" className="btn btn-primary">Submit Request</button>
                    </div>
                </div>
            </React.Fragment>
        );
        
        
    }

    render() {
        let { is_login, addNewAddress, user_company, user_address, user_city, user_state, user_zip, user_country, formData, errors, alert } = this.state;
        return (
            <React.Fragment>
                <main className="techtop-middle-div" id="catalog-request-section">
                    <section className="py-2">  
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="default-title">
                                        <h2 className="txt-color2">Catalog Request</h2>
                                    </div>                                      
                                </div>
                            </div>
                            <div className="row mt-1 g-5">
                                <AlertMessage
                                    type={alert.type}
                                    message={alert.message}
                                    onClose={() => this.setState({alert: { type: '', message: '' }})}
                                />
                                <div className="col-md-5">
                                    <div className="row">
                                        <form method="post" onSubmit={this.handleSubmit.bind(this)}>
                                            <div className="col-md-12">
                                                {/* <p>Full Name: (Company Name Logged in As)</p>    */}
                                                <div className="mb-3 required-field">
                                                    <div className="row">
                                                        <div className="col-md-2 align-self-center">
                                                            <label htmlFor="attn" className="form-label">Attn:</label>
                                                        </div>  
                                                        <div className="col-md-10">
                                                            <input type="text" className="form-control" id="attn" placeholder='Attn' name="attn" value={formData.attn} onChange={this.handleChange.bind(this, 'attn')} />
                                                            {errors.attn && <div className="text-danger">{errors.attn}</div>}
                                                        </div>  
                                                    </div>  
                                                </div>
                                                {is_login && !addNewAddress &&(
                                                    <React.Fragment>
                                                        <div className="mb-3">
                                                            <button type="button" className="btn btn-primary" onClick={this.handleAddAddress.bind(this)}>Add New Address</button>
                                                        </div>
                                                        <div className="mb-3">
                                                            <p className="m-0">Deliver To:</p>
                                                            <p className="m-0">{user_company}</p>
                                                            <p className="m-0">{user_address}</p>
                                                            <p>{user_city !== 'None' && user_city !== '' && `${user_city},`} {user_state !== 'None' && user_state !== '' && `${user_state},`} {user_zip !== 'None' && user_zip !== '' && `${user_zip},`} {user_country !== 'None' && user_country !== '' && `${user_country}`}</p>
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                            </div>
                                            {this.renderForm()}
                                        </form>
                                    </div>
                                </div>
                                <div className="col-md-7">
                                    <h5 class="text-center">Ordering a Techtop catalog is free and easy!</h5>   
                                    <p>Simply fill in the form and click the check box for the catalog(s) you would like sent.</p>
                                    <p>Need it now? View our Full Catalog online and enjoy all the benefits of our print and share options with the search capability.</p>
                                    <p class="text-center">Techtop's digital Full Catalog is just a <a href="https://online.flippingbook.com/shelf/391239/782262/" class="text-decoration-underline" target="_blank">click away.</a></p> 
                                    <div className="row">
                                        {this.renderCatalogs()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <Loader isLoading={this.state.isLoaderVisible}/>
                </main>
            </React.Fragment>
        );
    }
}

export default CatalogRequest;